import React, { useEffect } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "./animations";

import configFrontend from "../../../../../config/frontend";

import assets from "./assets";
import { format as dateFormat } from "date-fns";

import { de, enUS } from "date-fns/locale";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import { utcToZonedTime } from "date-fns-tz";
import countries from "../../../../../language/de/countries.json";
import { useTranslation } from "react-i18next";
import Image from "../../../../shared/components/Image";
import {
  getDynamicLogoPath,
  toIsoDateString,
} from "../../../../shared/utils/functions";
import {
  getDateInZone,
  getTimeInZone,
} from "../../../../shared/utils/dateHelpers";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { globalAssets } from "../../../assets/global/assets";
// import outroVideo9x16 from "../../../assets/outros/outro_playoffs_9x16.webm";

require("./style/style.scss");
require("./style/animation.scss");

const translations = {
  Group: "Gruppe",
};

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;

  const { t, i18n } = useTranslation();

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name,
        });
      }
    }

    //handle outro video BEGIN
    // if(mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener("loadedmetadata", function() {
    //       const that = this;
    //       setTimeout(()=> {
    //         outroVideo?.css('opacity', 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter)
    //     }, false);
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");

  const lng = i18n?.language;

  const { options, fields, dynamic } = templateData;
  const color1 = getContentById("color1", options);
  const color2 = getContentById("color2", options);

  const headerEn = getContentById("headline-en", fields);
  const headerDe = getContentById("headline-de", fields);
  const textDe = getContentById("text-de", fields);
  const textEn = getContentById("text-en", fields);
  const openerType = getContentById("openerType", fields);

  const teamHome = _.get(dynamic, "assets.teamHome");
  const teamAway = _.get(dynamic, "assets.teamAway");
  const event = data?.event;
  // const nextGame = _.get(dynamic, "nextGame");
  const matchInfo = _.get(dynamic, "matchInfo");
  // const teamDataStyles = _.get(teamData, "styles", {});

  // const thisGameDateTmp = new Date(toIsoDateString(matchInfo?.date, matchInfo?.time)) || '';

  // const timeZone = 'Europe/Berlin';
  // const thisGameDate = utcToZonedTime(thisGameDateTmp, timeZone);

  const feedType = _.get(data, "event.feedType", "opta");

  const isValidDate = Boolean(matchInfo?.date);

  const isoMatchDate = toIsoDateString(matchInfo?.date, matchInfo?.time);
  const matchDate = matchInfo?.time
    ? new Date(isoMatchDate)
    : new Date(matchInfo?.date);
  const time = matchInfo?.time ? getTimeInZone(matchDate, lng, true) : "-:-";
  const date = matchInfo?.time ? getDateInZone(matchDate, lng) : "-";
  let competitionId = dynamic?.matchInfo?.competition?.id;

  if (feedType === "heimspiel") {
    competitionId = "olympic_2024";
  }

  const backgroundImage = getMainBackground(format, _.get(dynamic, "teamSide"));

  const homeTeam = matchInfo?.contestant?.[0];
  const awayTeam = matchInfo?.contestant?.[1];
  const scores = _.get(dynamic, "liveData.matchDetails.scores.total");
  
  const halfScores = _.get(dynamic, "liveData.matchDetails.scores.ht");
  const penalties = _.get(dynamic, "liveData.matchDetails.scores.pen");
  const hasPenalty = _.has(dynamic, "liveData.matchDetails.scores.pen");
  const hasExtraTime =
    _.has(dynamic, "liveData.matchDetails.scores.et") && !hasPenalty;
  const matchStatus = _.toLower(dynamic?.liveData?.matchDetails?.matchStatus);
  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""} side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock>
        <Backgrounds bg1={backgroundImage} loop={true} />

        <div className={"wc-content wc-content-v2"}>
          <ProgressBar height={"8px"} />

          <div className={"qatar-logo"}>
            <img src={globalAssets.of_logo} />
          </div>

          <div className="header-wrapper">
            <div className={"matchday-competition-logo"}>
              <Image
                src={`/images/dynamic/soccer/competition/${competitionId}.svg`}
              />
            </div>
            {dynamic?.matchInfo?.week &&
              <span className="matchday-week">
                {t("Matchday")} {dynamic.matchInfo.week}
              </span>
            }
          </div>
          <div className={"main-header"}>
            {openerType === "global" ? (
              <>
                <div className={"competition-name-global"}>
                  {!headerEn
                    ? t(
                      matchInfo?.competition?.knownName ||
                      matchInfo?.competition?.name,
                    )
                    : null}
                </div>
                {!headerEn ? (
                  <span >
                    {t("templates.In Numbers")}
                  </span>
                ) : (
                  <span >
                    {lng === "de" ? headerDe : headerEn}
                  </span>
                )}{" "}
                <br />
                {textDe ? (
                  <div
                    className={"extra-custom-multiline"}
                    dangerouslySetInnerHTML={{
                      __html: lng === "de" ? textDe : textEn,
                    }}
                  ></div>
                ) : null}
              </>
            ) : (
              <>
                {/*{t("templates.Your")}*/}
                {/*<br />*/}
                <span >
                  {t("Results")}
                </span>
              </>
            )}
          </div>


          {openerType === "global" || openerType === "customZone" ? null : (
            <div className={"info-block"}>
              <div className={"teams-block"}>
                <div className={"team-vs"}>
                  <div className={"versus"}>
                    {/* {t("templates.vs")} */}
                    <div className={"score-home"}>
                      {scores?.home || (matchStatus === "fixture" ? "-" : 0)}
                    </div>
                    <div className={"separator"}>-</div>
                    <div className={"score-away"}>
                      {scores?.away || (matchStatus === "fixture" ? "-" : 0)}
                    </div>
                  </div>

                  <div className={"half-versus"}>
                    {/* {t("templates.vs")} */}
                    <div className={"score-home"}>
                      {"("}{halfScores?.home || (matchStatus === "fixture" ? "-" : 0)}
                    </div>
                    <div className={"separator"}>-</div>
                    <div className={"score-away"}>
                      {halfScores?.away || (matchStatus === "fixture" ? "-" : 0)}{")"}
                    </div>
                  </div>
                </div>
                <div className="matchday-team-logo-container">
                  <div className={"team-logo-container home"}>
                    <Image
                      className="team-logo"
                      src={getDynamicLogoPath({ team: homeTeam, competitionId })}
                    />
                  </div>
                </div>
                <div className="matchday-team-logo-container">

                  <div className={"team-logo-container away"}>
                    <Image
                      className="team-logo"
                      src={getDynamicLogoPath({ team: awayTeam, competitionId })}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `background_1920`);
};

export default Index;
